/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneItpLibrarySheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ITP-LIBRARY-001
 * PURPOSE: Browse saved ITPs on the phone. The job Overview card uses the same list.
 */
import { MobileSheet } from '@quotech/ui'
import { JobItpLibrary } from '../../../JobItpLibrary'

export function QaPhoneItpLibrarySheet({
  open,
  onClose,
  jobId,
  orgId,
}: {
  open: boolean
  onClose: () => void
  jobId: number
  orgId?: number
}) {
  return (
    // Reused from: packages/job-hub/src/jobs/tabs/JobItpLibrary.tsx (JobItpLibrary)
    <JobItpLibrary
      jobId={jobId}
      orgId={orgId}
      variant="sheet"
      browsing={open}
      frame={(list) => (
        // Reused from: packages/ui/src/mobile/MobileSheet.tsx (MobileSheet)
        <MobileSheet open={open} onClose={onClose} title="ITP library" size="full">
          {list}
        </MobileSheet>
      )}
    />
  )
}
